import React from "react";
import styles from "./styles/Button.module.css";

export default function Button({
  children = null,
  className = null,
  onClick = null,
  color = null,
  style = null,
  size = null,
  disabled = false,
  used = null,
}) {
  let colorStyles, sizeStyle;

  switch (size) {
    case "medium":
      sizeStyle = styles.btnMedium;
      break;

    case "small":
      sizeStyle = styles.btnSmall;
      break;

    default:
      sizeStyle = styles.btn;
  }

  switch (color) {
    case "blue":
      colorStyles = styles.blue;
      break;
    case "white":
      colorStyles = styles.white;
      break;
    case "beige":
      colorStyles = styles.beige;
      break;
    case "lightBlue":
      colorStyles = styles.lightBlue;
      break;
    case "brightBlue":
      colorStyles = styles.brightBlue;
      break;
    case "none":
      colorStyles = null;
      break;

    default:
      colorStyles = styles.orange;
  }
  const classes = [sizeStyle, colorStyles, className];

  if (disabled) {
    classes.push(styles.disabled);
  }
  if (used) {
    classes.push(styles.used);
  }

  return (
    <button
      style={style}
      onClick={(e) => !disabled && onClick && onClick(e)}
      className={classes.join(" ")}
    >
      {children}
    </button>
  );
}
